import React, { useEffect, useState } from "react";
import { Spin } from "antd";

import { USER_STORAGE } from "constants/index";
import { notificationErroInternal } from "util/api-utils";
import { getReviewUserById } from "services/review/review-service";

import FormUserComparationAqua from "./reviews-drawer-comparation-aqua";

const ReviewsClientUserAqua = () => {
  const [loading, setLoading] = useState(true);
  const [imgAvatar, setImgAvatar] = useState("");
  const [dataDrawer, setDataDrawer] = useState({});

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { id } = JSON.parse(localStorageItem);
      getReviewUserById(id)
        .then((res) => {
          setDataDrawer(res);
          setImgAvatar(res.img);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
        });
    }
  }, []);

  return (
    <Spin spinning={loading}>
      <FormUserComparationAqua dataDrawer={dataDrawer} imgAvatar={imgAvatar} />
    </Spin>
  );
};
export default ReviewsClientUserAqua;
